import { supabase } from '../lib/supabase';

const DIAS_PARA_DESTAQUE = 3;

// Lista vendas do GHL (status='realizada') que ainda não têm ticket completo:
// ou nunca tiveram ticket (não existe linha em ghl_vendas_tickets), ou o ticket
// existente está com status='pendente' (reaberto por rejeição).
export async function listarTicketsPendentes({ role, nomeUsuario }) {
    const { data: vendas, error: errVendas } = await supabase
        .from('ghl_vendas')
        .select('ghl_opportunity_id, contato_nome, telefone_canonico, produto, valor_venda, vendido_em, closer_ghl_user_id, sdr_ghl_user_id')
        .eq('status', 'realizada')
        .order('vendido_em', { ascending: true });
    if (errVendas) throw errVendas;
    if (!vendas || vendas.length === 0) return [];

    const oppIds = vendas.map(v => v.ghl_opportunity_id);
    const { data: tickets, error: errTickets } = await supabase
        .from('ghl_vendas_tickets')
        .select('ghl_opportunity_id, status, motivo_rejeicao')
        .in('ghl_opportunity_id', oppIds);
    if (errTickets) throw errTickets;

    const ticketPorOpp = new Map((tickets ?? []).map(t => [t.ghl_opportunity_id, t]));

    const pendentes = vendas.filter(v => {
        const t = ticketPorOpp.get(v.ghl_opportunity_id);
        return !t || t.status === 'pendente';
    });
    if (pendentes.length === 0) return [];

    const ghlUserIds = [...new Set(pendentes.flatMap(v => [v.closer_ghl_user_id, v.sdr_ghl_user_id]).filter(Boolean))];
    const { data: alias, error: errAlias } = ghlUserIds.length
        ? await supabase.from('ghl_pessoa_alias').select('ghl_user_id, pessoa_nome').in('ghl_user_id', ghlUserIds)
        : { data: [], error: null };
    if (errAlias) throw errAlias;
    const nomePorGhlUserId = new Map((alias ?? []).map(a => [a.ghl_user_id, a.pessoa_nome]));

    const agora = Date.now();
    let visiveis = pendentes.map(v => {
        const closerNome = nomePorGhlUserId.get(v.closer_ghl_user_id) ?? null;
        const sdrNome = nomePorGhlUserId.get(v.sdr_ghl_user_id) ?? null;
        const dias = v.vendido_em
            ? Math.floor((agora - new Date(v.vendido_em).getTime()) / (1000 * 60 * 60 * 24))
            : 0;
        return {
            ghl_opportunity_id: v.ghl_opportunity_id,
            contato_nome: v.contato_nome,
            telefone: v.telefone_canonico,
            produto: v.produto,
            valor_venda: v.valor_venda,
            vendido_em: v.vendido_em,
            dias_sem_completar: dias,
            destaque: dias >= DIAS_PARA_DESTAQUE,
            closer_nome: closerNome,
            sdr_nome: sdrNome ?? 'não identificado',
            motivo_rejeicao: ticketPorOpp.get(v.ghl_opportunity_id)?.motivo_rejeicao ?? null,
        };
    });

    if (role === 'closer') {
        visiveis = visiveis.filter(v => v.closer_nome && v.closer_nome === nomeUsuario);
    }
    // role === 'gestor': vê todos, sem filtro (spec 6.2).

    return visiveis;
}
